var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIcParticipants = function SvgIcParticipants(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#767884",
    strokeLinecap: "round",
    strokeWidth: 1.2,
    d: "M10 17.75a7.75 7.75 0 1 0 0-15.5 7.75 7.75 0 0 0 0 15.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#767884",
    d: "M10.402 7.805a.735.735 0 0 0 .477-.932.735.735 0 0 0-.931-.477.735.735 0 0 0-.477.932c.131.391.54.608.931.477M12.769 7.04a.735.735 0 0 0 .477-.932.735.735 0 0 0-.931-.477.735.735 0 0 0-.478.931c.132.392.54.61.932.478"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#767884",
    strokeLinecap: "round",
    strokeWidth: 1.2,
    d: "M10.64 8.983a1.84 1.84 0 0 0 1.418.114c.47-.152.853-.478 1.082-.916"
  })));
};
export default SvgIcParticipants;